'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:send-uri');
}

var env = require('./env.js');

/*eslint-disable no-undef, block-scoped-var, no-alert */
var strategy = {
    'alert': function(uri) { window.alert(uri); },
    'prompt': function(uri) { window.prompt(uri); },
    'HBNB': {
        'android': function(uri) { HBNB.sendBridgeMessage(uri); },
        'ios': function(uri) { HBNB.postMessage(uri); }
    }
};
/*eslint-enable no-undef, block-scoped-var, no-alert */

var sendURI;
if (env.platform === 'ios') {
    sendURI = strategy['HBNB']['ios'];
} else if (env.platform === 'android') {
    if (env.supportPrompt) {
        // android app >= 6.0 support window.prompt
        sendURI = strategy['prompt'];
    } else {
        sendURI = strategy['HBNB']['android'];
    }
} else {
    sendURI = strategy['alert'];
}

if (process.env.NODE_ENV !== 'production') {
    debug('sendURI = %s', sendURI);
}

module.exports = sendURI;



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/invoke/send-uri.js
// module id = 220
// module chunks = 10 11 12 13 14 15 16 17 18 19